import React from 'react';
import styled from "styled-components";
import { Search } from '@styled-icons/boxicons-regular';
import { isMobile } from "../../../utils/isMobile";
import { Close } from "@styled-icons/evaicons-solid";


const StyledSearch = styled.div`
  // width: 232px;
  display: flex;
  position: relative;
  margin-left: auto;
  border-left: solid 1px #EFEDEB;
  padding-left: 21px;
  align-items: center;

  :focus + .left-icon{
      fill: red;
  }

  @media(max-width: 767px){
    height: 48px;
    // width: 183px;
    position: relative;
    margin-left: 0;
    border-left: solid 1px #EFEDEB;
    flex: 0.5;
  }
`;



const Input = styled.input`{
  width: 232px;
  color: #747474;
  font-family: Mallory;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 17px;
  padding-left: 21.5px;
  display: inline-block;
  border: none;
  transition: 0.3s;
  &:focus{
    outline: 0;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: #747474;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
  }
  :-ms-input-placeholder {
    color: #747474;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
  }
  

  @media(max-width: 767px){
    color: #747474;
    padding-top: 0px;
    padding-left: 32px;
    font-family: Mallory;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
    display: inline-block;
    border: none;
    transition: 0.3s;
    background: transparent;
    height: 100%;
    width: 170px;
    
    ::placeholder,
    ::-webkit-input-placeholder {
      color: #747474;
      font-family: Mallory;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 17px;
    }
    :-ms-input-placeholder {
      color: #747474;
      font-family: Mallory;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 17px;
    }
    
  }
}
`;

const SearchIcon = styled(Search)`
    position: absolute;
    left: 21px;
    top: 51%;
    transform: translateY(-50%);
    transition: 0.3s;
    fill: #747474;
    height: 24px;
    width: 24px;

    @media(max-width: 767px){
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
      transition: 0.3s;
      fill: #747474;
      height: 24px;
      width: 24px;
    }
    `;

const SearchIconContainer = styled.div`
    padding-left: 10px;
`

// const SearchMobileButton



const fullBar = {
  'border': 'none',
  'width': '320px',
  'paddingLeft': '12px'
}

const fullInput = {
  'paddingLeft': '32px'
}

const halfBar = {
  'borderLeft': 'solid 1px #EFEDEB'
}

const SearchBar = (props) => {

  return (
    <>
      <StyledSearch style={(isMobile() && props.type == false) ? fullBar : halfBar}>
        {
          isMobile() && props.type == false ?
            <></>
            :
            <SearchIconContainer>
              <SearchIcon className="left-icon" />
            </SearchIconContainer>
        }
        <Input style={(isMobile() && props.type == false) ? fullInput : null}  onClick={props.handleClick} placeholder={isMobile() ? "SEARCH BLOG" : (props.isSearched ? "" : "SEARCH MILLIGRAM NOTES")} value={props.searchValue} onChange={props.handleInputChange} />
      </StyledSearch>
    </>
  )
}


export default SearchBar;